import React, { Fragment } from 'react'

import classes from './EmpPositions.scss'
import PositionRow from './PositionRow/PositionRow'
import { IconButton, Grid, Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

import { withTranslate } from 'react-redux-multilingual'
import _ from 'lodash'
import * as moment from 'moment'

const empPositions = ({
  positions,
  rowInputChanged,
  actionToClicked,
  delegateClicked,
  addRowClicked,
  deleteRowClicked,
  dropdownOptions,
  primaryRowIndex,
  edit,
  translate
}) => {
  const CurrentDate = moment(new Date()).format('YYYY-MM-DD')

  let weightPosition = positions.filter(item => {
    let date = item.effective_date.value
    if (item.effective_date.value !== null) {
      date = moment(item.effective_date.value)
    }

    return (
      (moment(date).isSame(CurrentDate) || moment(date).isBefore(CurrentDate)) &&
      item.is_active.value
    )
  })

  let sumWeight = _.sumBy(weightPosition, position => +position.weight_percent.value || 0)

  const rows = positions.map((position, index) => {
    return (
      <PositionRow
        key={index}
        index={index}
        last={positions.length - 1 === index}
        positionForm={position}
        actionToClicked={() => actionToClicked(index)}
        delegateClicked={() => delegateClicked(index)}
        // addClicked={addRowClicked}
        deleteClicked={() => deleteRowClicked(index)}
        rowInputChanged={(formKey, e) => rowInputChanged(formKey, index, e)}
        dropdownOptions={dropdownOptions}
        primaryRowIndex={primaryRowIndex}
        edit={edit}
      />
    )
  })
  return (
    <Fragment>
      <Grid item xs>
        <Typography align={'left'} variant={'h5'}>{`${translate('details')} (${translate(
          'weightPercent'
        )} : ${sumWeight})`}</Typography>
      </Grid>
      <Grid item xs>
        {rows}
        <div className={classes.AddRowWrapper}>
          <div className={classes.Button}>
            <IconButton color={'primary'} onClick={addRowClicked}>
              <AddIcon />
            </IconButton>
          </div>
        </div>
      </Grid>
    </Fragment>
  )
}

export default withTranslate(empPositions)
